import Main from "./components/Main";
import Login from "./pages/Login";
import { useAdmin } from "./contexts/AdminContext";

function App() {
  const { admin } = useAdmin();

  return <>{admin ? <Main /> : <Login />}</>;
}

export default App;
